import * as React from 'react';
import styled from '@emotion/styled';
import H3 from '@base/H3/H3';
import { useRouter } from 'next/router';
import { breakpoints } from '@styles/index';
import TopicCard from './TopicCard';

const Container = styled.div`
  margin-top: 80px;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin-top: 56px;
  }
`;

const Title = styled(H3)`
  margin-bottom: 24px;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    font-size: 20px;
  }
`;

const ChildrenTopics = styled.div`
  grid-column: span 18;
  display: grid;
  grid-template-columns: repeat(18, 1fr);
  grid-gap: 16px;
  & a {
    grid-column: span 6;
    :hover {
      text-decoration: none;
    }
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    grid-column: span 10;
    grid-template-columns: repeat(10, 1fr);
    grid-column-gap: 8px;
    grid-row-gap: 16px;
    & a {
      grid-column: span 10;
    }
  }
`;

function Topics({ isGTP, topics }) {
  const router = useRouter();
  const { goalUID, goalSlug } = router.query;

  return topics?.map((topic) => {
    const childTopics = topic.children_topics.filter(
      (childTopic) => +childTopic.concepts_count > 0
    );

    return childTopics.length > 0 ? (
      <Container key={topic.uid}>
        <Title color="var(--color-text-primary)">{topic.name}</Title>
        <ChildrenTopics>
          {childTopics.map((childTopic) => {
            const asPathLink = `/goal/${goalSlug}/${goalUID}/practice/topics/${childTopic.uid}`;
            const href =
              '/goal/[goalSlug]/[goalUID]/practice/topics/[topicUid]';

            return (
              <TopicCard
                color={topic.practice_session_color}
                topic={childTopic}
                key={childTopic.uid}
                asLink={asPathLink}
                href={href}
                isGTP={isGTP}
              />
            );
          })}
        </ChildrenTopics>
      </Container>
    ) : null;
  });
}

export default Topics;
